<style scoped>
@import url("../../assets/sanger.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/常规分子项目/banner8.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>细胞鉴定</h1>-->
<!--          <h2 class="mt10">Cell identification</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">承接人源细胞STR鉴定，接受鼠源细胞鉴定。</p>
      <div class="c-title">结果交付<small>Delivery Of Results</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/identification_1.png" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required">
            <p class="mb20">1、提供20个特征位点特征峰图；</p>
            <p class="mb30">2、提供中英文细胞鉴定报告，可直接用于外文杂志投稿。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">案例<small>Case</small></div>
      <div class="tc"><img src="@/assets/images/identification_2.png"></div>
      <div class="tc mt30"><img src="@/assets/images/identification_3.png"></div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/identification.vue